import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import HeaderMenu from './components/HeaderMenu.vue'
import FooterMenu from './components/FooterMenu.vue'
import SessionNav from './components/SessionNav.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute()
const isSessionRoute = computed(() => {
  // Show session nav when route path is under /session OR when served on the session subdomain
  try {
    const host = (typeof window !== 'undefined' && window.location && window.location.hostname) ? window.location.hostname : ''
    if (host.startsWith('session.')) return true
  } catch (e) {
    // ignore
  }
  return route.path.startsWith('/session')
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isSessionRoute.value)
      ? (_openBlock(), _createBlock(SessionNav, { key: 0 }))
      : (_openBlock(), _createBlock(HeaderMenu, { key: 1 })),
    _createVNode(_component_router_view),
    _createVNode(FooterMenu)
  ], 64))
}
}

})